import React from "react";
import { TkSuperPowerTextProps } from "../../../type/componentsType/TkSuperPowerText";
import TkNameText from "./NormalPowerText/TkNameText";
import "./_style.scss";
import TkPhoneNum from "./NormalPowerText/TkPhoneNum";
import TkPostCode from "./NormalPowerText/TkPostCode";

/**
 * 特殊テキストボックス部品
 * TkSuperPowerTextコンポーネントは、typeプロパティに応じて、TkNameText、TkPhoneNum、TkPostCodeのいずれかのコンポーネントをレンダリングします。
 * @param {TkSuperPowerTextProps} props - Reactコンポーネントのプロパティ
 * @param {string} props.type - レンダリングするコンポーネントのタイプ
 * @return TkSuperPowerText 特殊テキストボックス部品
 * @throws {Error} - typeプロパティにname、phoneNum、postcode以外の値が渡されたときに発生します。
 */
const TkSuperPowerText: React.FC<TkSuperPowerTextProps> = (props) => {
  const { type, disabled, inputProps, wantToSetValue, dataTestid, 
    onGetInputValue,...rest } =
    props;

  let ResComponent: React.FC<TkSuperPowerTextProps> = TkNameText;

  if (type === "name") {
    ResComponent = TkNameText;
  } else if (type === "phoneNum") {
    ResComponent = TkPhoneNum;
  } else if (type === "postcode") {
    ResComponent = TkPostCode;
  }

  return (
    <ResComponent
      type={type}
      disabled={disabled}
      inputProps={inputProps}
      wantToSetValue={wantToSetValue}
      onGetInputValue={onGetInputValue}
      {...rest}
    ></ResComponent>
  );
};

export default TkSuperPowerText;
